import { useEffect, useState } from "react";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Dashboards/EditDashboardState.css";

const EditDashboardState = ({selectedEditDashboardState,setSelectedEditDashboardState,setDashboardStates}) =>{
    const [dashboardStateName,setDashboardStateName] = useState('');
    const [dashboardStateId,setDashboardStateId] = useState('');
    const [isRootState,setIsRootState] = useState(false);
    const [showTitle,setShowTitle] = useState(true);
    const discardEditDashboardState = () =>{
        setDashboardStateName('');
        setDashboardStateId('');
        setIsRootState(false);
        setShowTitle(false);
        setSelectedEditDashboardState(null);
    };
    const saveEditDashboardState = () =>{
        setDashboardStates(prev =>{
            return prev.map(state =>{
                if(state.id === dashboardStateId){
                    return{
                        ...state,
                        name:dashboardStateName,
                        rootState:isRootState,
                        showTitle:showTitle
                    };
                }
                if(isRootState && state.rootState){
                    return{...state,rootState:false}
                }
                return state;
            })
        });
        discardEditDashboardState();
    };
    const allowUpdate = () =>{
        return dashboardStateName !== '' 
        && (selectedEditDashboardState?.name !== dashboardStateName
        || selectedEditDashboardState?.rootState !== isRootState
        || selectedEditDashboardState?.showTitle !== showTitle)
    };
    useEffect(() =>{
        if(!selectedEditDashboardState) return;
        setDashboardStateName(selectedEditDashboardState?.name);
        setDashboardStateId(selectedEditDashboardState?.id);
        setIsRootState(selectedEditDashboardState?.rootState);
        setShowTitle(selectedEditDashboardState?.showTitle);
    },[selectedEditDashboardState]);
    if(!selectedEditDashboardState) return null;
    return(
        <div className="edit-dashboard-state-parent-container">
            <div className="edit-dashboard-state-container">
                <div className="edit-dashboard-state-header">
                    <h3>Edit dashboard state</h3>
                    <p onClick={() => discardEditDashboardState()}>&#10006;</p>
                </div>
                <div className="edit-dashboard-state-body">
                    <div className="edit-dashboard-state-entry-container">
                        <p>Name<span>*</span></p>
                        <input
                            value={dashboardStateName}
                            onChange={(e) =>setDashboardStateName(e.target.value)}
                        />
                    </div>
                    <div className="edit-dashboard-state-entry-container">
                        <p>State Id<span>*</span></p>
                        <input readOnly value={dashboardStateId}/>
                    </div>
                    <div className="edit-dashboard-state-checkboxes-container">
                        <label>
                            <input
                                type="checkbox"
                                checked={isRootState}
                                onChange={(e) => setIsRootState(selectedEditDashboardState?.rootState || e.target.checked)}
                            />
                            <span>Root state</span>
                        </label>
                        <label>
                            <input
                                type="checkbox"
                                checked={showTitle}
                                onChange={(e) => setShowTitle(e.target.checked)}
                            />
                            <span>Show title</span>
                        </label>
                    </div>
                </div>
                <div className="edit-dashboard-state-buttons-container">
                    <button className="cancel-button" onClick={() => discardEditDashboardState()}>
                        Cancel
                    </button>
                    <button className={`save-button ${allowUpdate()? 'active':'inactive'}`}
                        onClick={() => {if(allowUpdate())saveEditDashboardState();}}>
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
};
export default EditDashboardState;